export const legacyPortfolioTeamRoute = {
	name: 'legacy-portfolio-team',
	path: '/secure/TeamManagement.jspa',
};
